import api from "./api";

const normalizeScheduledBookingStatus = (booking) => {
  const bookingStatus = String(booking?.BookingStatus || "").trim().toUpperCase();
  const hasScheduleTimes = Boolean(booking?.bsTime && booking?.beTime);
  const isRealtimeLabel =
    bookingStatus === "R" ||
    (bookingStatus.includes("REAL") && bookingStatus.includes("TIME"));

  if (hasScheduleTimes && (bookingStatus === "" || bookingStatus === "S" || isRealtimeLabel)) {
    return { ...booking, BookingStatus: "S" };
  }

  return booking;
};

export const getAllBookings = async () => {
  const response = await api.get("/BookingDetails/GetBookingDetails");
  const data = response?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.resultSet)) return data.resultSet;
  return [];
};

export const cancelBooking = async (booking) => {
  if (!booking?.bId) {
    throw new Error("Booking id is required.");
  }

  const payload = [
    {
      ...booking,
      status: "C",
    },
  ];

  return api.post("/BookingRegister/PostForkBooking", payload);
};

// new helper for fork bookings
export const postForkBooking = async (bookingArray) => { 
  return api.post("/BookingRegister/PostForkBooking", bookingArray);
};

export const PostBookingRequestDetails = async (bookingArray) => { 
  return api.post("/BookingRegister/PostBookingRequestDetails", bookingArray);
};

// driver-only update (status / time fields) to avoid overwriting booking data
export const postForkBookingForDriver = async (bookingArray) => {
  return api.post("/BookingRegister/PostBookingRequestDetails", bookingArray);
};

export const getForkBookingDetails = async (bookingId) => {
  try {
    const response = await api.get(`/BookingRegister/GetForkBookingDetails?BId=${bookingId}`);
    if (Array.isArray(response.data)) return response.data.map(normalizeScheduledBookingStatus);
    if (Array.isArray(response.data?.resultSet)) return response.data.resultSet.map(normalizeScheduledBookingStatus);
    return normalizeScheduledBookingStatus(response.data);
  } catch (error) {
    console.error(`Error fetching details for booking ID ${bookingId}:`, error);
    throw error;
  }
};

// Fetch all fork booking details (no specific booking ID)
export const getForkBookingDetailsAll = async () => {
  try {
    const response = await api.get(`/BookingRegister/GetForkBookingDetails`);
    console.log("[getForkBookingDetailsAll] API response:", response.data);
    
    let bookings = [];
    if (Array.isArray(response.data)) {
      bookings = response.data.map(normalizeScheduledBookingStatus);
    } else if (Array.isArray(response.data?.resultSet)) {
      bookings = response.data.resultSet.map(normalizeScheduledBookingStatus);
    }
    
    return bookings;
  } catch (error) {
    console.error("[getForkBookingDetailsAll] Error fetching fork booking details:", error);
    return [];
  }
};

// Fetch general booking details
export const getFBookingDetails = async () => {
  try {
    const response = await api.get(`/BookingDetails/GetFBookingDetails`);
    console.log("[getFBookingDetails] API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("[getFBookingDetails] Error fetching booking details:", error);
    throw error;
  }
};
 
// export const getScheduledBookings = async () => {
//   try {
//     const response = await api.get(`/BookingRegister/GetMainForkBookingDetails?bsno=3000500&bid&bdate`);
//     console.log("[getScheduledBookings] API response:", response.data);
    
//     let bookings = [];
//     if (Array.isArray(response.data)) {
//       bookings = response.data.map(normalizeScheduledBookingStatus);
//     } else if (Array.isArray(response.data?.resultSet)) {
//       bookings = response.data.resultSet.map(normalizeScheduledBookingStatus);
//     }
    
//     const isScheduledBooking = (booking) => {
//       const bookingStatus = String(booking?.BookingStatus || "").trim().toUpperCase();
//       const hasScheduleTimes = Boolean(booking?.bsTime && booking?.beTime);
//       if (bookingStatus === "S" || bookingStatus === "SHEDULE BOOKING" || bookingStatus === "SCHEDULE BOOKING") {
//         return true;
//       }
//       // Some records are mislabeled as Real-time but still contain scheduled times.
//       if (bookingStatus.includes("REAL") && bookingStatus.includes("TIME") && hasScheduleTimes) {
//         return true;
//       }
//       return false;
//     };

//     // Filter only scheduled main bookings.
//     const filteredBookings = bookings
//       .filter(isScheduledBooking)
//       .map((booking) => normalizeScheduledBookingStatus(booking));
    
//     console.log("[getScheduledBookings] Filtered scheduled bookings:", filteredBookings.length);
//     return filteredBookings;
//   } catch (error) {
//     console.error("[getScheduledBookings] Error fetching scheduled bookings:", error);
//     throw error;
//   }
// };



export const getScheduledBookings = async () => {
  try { 
    const persistRoot = JSON.parse(localStorage.getItem("persist:root"));
    const auth = JSON.parse(persistRoot?.auth || "{}");

    const serviceNo = auth?.userDetails?.ServiceNo;
    const role = auth?.userDetails?.role;
 
    let url = "";

    if (role === "Employee") {
      url = `/BookingRegister/GetMainForkBookingDetails?bsno=${serviceNo}&bid&bdate`;
    } else if (role === "Driver") {
      url = `/BookingRegister/GetMainForkBookingDetails?dsno=${serviceNo}`;
    } else {
      throw new Error("Invalid role");
    }
 

    const response = await api.get(url);
    console.log("[getScheduledBookings] API response:", response.data);

    let bookings = [];

    if (Array.isArray(response.data)) {
      bookings = response.data.map(normalizeScheduledBookingStatus);
    } else if (Array.isArray(response.data?.resultSet)) {
      bookings = response.data.resultSet.map(normalizeScheduledBookingStatus);
    }

    const isScheduledBooking = (booking) => {
      const bookingStatus = String(booking?.BookingStatus || "")
        .trim()
        .toUpperCase();

      const hasScheduleTimes = Boolean(booking?.bsTime && booking?.beTime);

      if (
        bookingStatus === "S" ||
        bookingStatus === "SHEDULE BOOKING" ||
        bookingStatus === "SCHEDULE BOOKING"
      ) {
        return true;
      }

      if (
        bookingStatus.includes("REAL") &&
        bookingStatus.includes("TIME") &&
        hasScheduleTimes
      ) {
        return true;
      }

      return false;
    };

    const filteredBookings = bookings
      .filter(isScheduledBooking)
      .map((booking) => normalizeScheduledBookingStatus(booking));

    console.log(
      "[getScheduledBookings] Filtered scheduled bookings:",
      filteredBookings.length
    );

    return filteredBookings;
  } catch (error) {
    console.error(
      "[getScheduledBookings] Error fetching scheduled bookings:",
      error
    );
    throw error;
  }
};

// Fetch fork booking details for a specific date
export const getForkBookingDetailsByDate = async (date) => {
  try {
    // Format date as MM/DD/YYYY for API
    const dateObj = new Date(date);
    const formattedDate = `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()}`;
    
    const response = await api.get(`/BookingRegister/GetForkBookingDetails?bdate=${formattedDate}`);
    console.log(`[getForkBookingDetailsByDate] Fetched bookings for date ${formattedDate}:`, response.data);
    
    let bookings = [];
    if (Array.isArray(response.data)) {
      bookings = response.data.map(normalizeScheduledBookingStatus);
    } else if (Array.isArray(response.data?.resultSet)) {
      bookings = response.data.resultSet.map(normalizeScheduledBookingStatus);
    }
    
    return bookings;
  } catch (error) {
    console.error(`[getForkBookingDetailsByDate] Error fetching fork booking details for date ${date}:`, error);
    return [];
  }
};

// Fetch booking details by assigned vehicle ID (optional booking ID)
export const getBookingDetailsByVehicleId = async ( ) => {
  try { 
    const persistRoot = JSON.parse(localStorage.getItem("persist:root"));
    const auth = JSON.parse(persistRoot?.auth || "{}");

    const serviceNo = auth?.userDetails?.ServiceNo;
    const role = auth?.userDetails?.role;
 
    let url = "";

    if (role === "Employee") {
      url = `/BookingRegister/GetMainForkBookingDetails?bsno=${serviceNo}&bid&bdate`;
    } else if (role === "Driver") {
      url = `/BookingRegister/GetMainForkBookingDetails?dsno=${serviceNo}`;
    } else {
      throw new Error("Invalid role");
    }
 

    const response = await api.get(url);
    console.log("[getScheduledBookings] API response:", response.data);

    let bookings = [];

    if (Array.isArray(response.data)) {
      bookings = response.data.map(normalizeScheduledBookingStatus);
    } else if (Array.isArray(response.data?.resultSet)) {
      bookings = response.data.resultSet.map(normalizeScheduledBookingStatus);
    }

    const isScheduledBooking = (booking) => {
      const bookingStatus = String(booking?.BookingStatus || "")
        .trim()
        .toUpperCase();

      const hasScheduleTimes = Boolean(booking?.bsTime && booking?.beTime);

      if (
        bookingStatus === "S" ||
        bookingStatus === "SHEDULE BOOKING" ||
        bookingStatus === "SCHEDULE BOOKING"
      ) {
        return true;
      }

      if (
        bookingStatus.includes("REAL") &&
        bookingStatus.includes("TIME") &&
        hasScheduleTimes
      ) {
        return true;
      }

      return false;
    };

    const filteredBookings = bookings
      .filter(isScheduledBooking)
      .map((booking) => normalizeScheduledBookingStatus(booking));

    console.log(
      "[getScheduledBookings] Filtered scheduled bookings:",
      filteredBookings.length
    );

    return filteredBookings;
  } catch (error) {
    console.error(
      "[getScheduledBookings] Error fetching scheduled bookings:",
      error
    );
    throw error;
  }
};
// Fetch only main fork booking rows (excludes sub-booking rows)
export const getMainForkBookingDetails = async () => {
  try {
    const response = await api.get(`/BookingRegister/GetMainForkBookingDetails`);

    if (Array.isArray(response?.data)) return response.data.map(normalizeScheduledBookingStatus);
    if (Array.isArray(response?.data?.resultSet)) return response.data.resultSet.map(normalizeScheduledBookingStatus);
    return [];
  } catch (error) {
    console.error("[getMainForkBookingDetails] Error fetching main fork booking details:", error);
    return [];
  }
};
